export default {
  url: 'https://m4c426zgxncrlpzkm63mjfpwtq.appsync-api.us-east-1.amazonaws.com/graphql',
  apiKey: 'da2-xn436ffpx5bhdd5hh4qksznvg4'
}
